module.exports = __webpack_public_path__ + "static/media/quest_app_button.10f9c97a.png";